import { stat } from "fs";
import Icon1 from "../assets/icons/Icon.js";
import { colors } from "../sexy";
import {
  Org,
  User,
  Attestation,
  Xml,
  MaitreOeuvre,
} from "../types/basicTypes.js";

import { getTypeString } from "../pages/Partners";

export const formatToCentimes = (value: number) => {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

// Transform clients into a DataGrid-friendly format
export function transformPartnersToTable(
  partnerss: MaitreOeuvre[],
  tab = "constructor",
  searchValue: string = ""
) {
  // Define columns for DataGrid, customize based on your data structure

  let partners = [...partnerss];
  if (tab === "constructor") {
    // only constructor
    partners = partners.filter(
      (partner) => partner.partner_type === "constructor"
    );
  } else if (tab === "architect") {
    // only architect
    partners = partners.filter(
      (partner) => partner.partner_type === "architect"
    );
  } else if (tab === "artisan") {
    // only architect
    partners = partners.filter((partner) => partner.partner_type === "artisan");
  } else if (tab === "expert") {
    // only architect
    partners = partners.filter((partner) => partner.partner_type === "expert");
  } else if (tab === "promotor") {
    // only architect
    partners = partners.filter(
      (partner) => partner.partner_type === "promotor"
    );
  } else if (tab === "mdo") {
    // only architect
    partners = partners.filter((partner) => partner.partner_type === "mdo");
  } else if (tab === "drawer") {
    // only architect
    partners = partners.filter((partner) => partner.partner_type === "drawer");
  } else if (tab === "other") {
    // only architect
    partners = partners.filter((partner) => partner.partner_type === "other");
  } else if (tab === "infiltro") {
    // only architect
    partners = partners.filter(
      (partner) => partner.partner_type === "infiltro"
    );
  } else if (tab === "all") {
    // only architect
    partners = partners;
  }

  if (searchValue !== "") {
    partners = partners.filter((partner) =>
      partner.name.toLowerCase().includes(searchValue.toLowerCase())
    );
  }

  const columns = [
    { field: "id", headerName: "ID", width: 200 },

    {
      field: "name",
      headerName: "Nom",
      flex: 1,

      renderCell: (params: any) => {
        let partner_type = params.row.partner_type;
        let row_id = params.id;

        return (
          <div className="flex flex-row items-center">
            <div>
              <div
                className={`inline-flex h-6 items-center rounded-full px-2 py-1 flex-row  font-light gap-1`}
              >
                <span className="whitespace-nowrap">{params.value}</span>
              </div>
            </div>
          </div>
        );
      },
    },
    { field: "type", headerName: "Type", flex: 1 },

    { field: "email", headerName: "Email", flex: 2 },

    { field: "ville", headerName: "Ville", flex: 1 },
    {
      field: "date",
      headerName: "Création",
      flex: 1,
      renderCell: (params: any) => {
        const date = params.value;
        return (
          <div className="flex flex-row items-center">
            {date && new Date(date.seconds * 1000).toLocaleString()}
          </div>
        );
      },
    },

    // Add more columns as needed
  ];
  // Create rows from the clients array
  let rows = partners.map((client: MaitreOeuvre, index) => ({
    id: client.id || index + 1, // Use client's ID or default index
    name: client.name || "",
    email: client.email || "",
    date: client.creation_date, // Use client's creation date or default
    client_type: client.partner_type || "", // Use client's type or default
    ville: client.city || "", // Use client's city or default
    type: getTypeString(client.partner_type) || "", // Use client's type or default
  }));

  rows = rows.sort((a, b) => {
    return a.name.trim().localeCompare(b.name.trim());
  });

  return { rows, columns }; // Return rows and columns for the DataGrid
}
export function transformFilesToTable(
  allfiles: Attestation[],
  activetab: any = "current",
  orgData: Org,
  searchValue: string,
  prefix: string
) {
  try {
    if (searchValue !== "") {
      allfiles = allfiles.filter((attestation: Attestation) =>
        attestation.name.includes(searchValue)
      );
    }

    if (activetab === "all") {
    } else if (
      activetab === "insulator" ||
      activetab === "carbon" ||
      activetab === "insulator_carbon"
    ) {
      console.log(activetab);

      allfiles = allfiles.filter((attestation: Attestation) => {
        return (
          attestation.type === "insulator" ||
          attestation.type === "carbon" ||
          attestation.type === "insulator_carbon"
        );
      });
    } else if (activetab === "rtb") {
      allfiles = allfiles.filter((attestation: Attestation) => {
        return attestation.type.includes("rtb");
      });
    }

    // Define columns for DataGrid, customize based on your data structure
    const columns = [
      { field: "id", headerName: "ID", width: 300 },
      {
        field: "type",
        headerName: "Icon",
        width: 100,
        renderCell: (params: any) => {
          let type = params.value;

          return (
            <div className="flex flex-row items-center gap-4 text-shadow_25">
              <div
                className={`w-16 h-8 bg-gradient-to-tr from-20%  to-60%
            ${
              type === "insulator"
                ? "from-yellow-400 to-black"
                : type === "carbon"
                ? "from-green-400 to-black"
                : type === "insulator_carbon"
                ? "to-yellow-400 via-50% from-green-400 via-black  to-80%"
                : type === "rtb_re2020"
                ? "from-purple-400 to-black"
                : type === "rtb_rt2012"
                ? "from-blue-400 to-black"
                : ""
            }
            bg-gray-100 rounded-md flex items-center justify-center`}
              >
                <Icon1 icon_name="file" size={20} fill={"white"}></Icon1>
              </div>
            </div>
          );
        },
      },
      {
        field: "type_text",
        headerName: "Type",
        width: 150,
        renderCell: (params: any) => {
          let type = params.value;

          return (
            <div className="flex flex-row items-center gap-4 text-shadow_50">
              <div>
                {type === "insulator"
                  ? "Isolant"
                  : type === "carbon"
                  ? "Carbone"
                  : type === "insulator_carbon"
                  ? "Isolant + Carbone"
                  : type === "rtb_re2020"
                  ? "RE2020"
                  : type === "rtb_rt2012"
                  ? "RT2012"
                  : ""}
              </div>
            </div>
          );
        },
      },
      {
        field: "num",
        headerName: "Numéro",
        width: 120,
        renderCell: (params: any) => {
          return (
            <div
              className={`flex flex-row gap-1 items-center  h-6 text-shadow_50 `}
            >
              {params.value}
            </div>
          );
        },
      },

      {
        field: "name",
        headerName: "Nom",
        flex: 1,
        renderCell: (params: any) => {
          return (
            <div className={`flex flex-row gap-1 items-center  h-6 `}>
              {params.value}
            </div>
          );
        },
      },

      {
        field: "octets",
        headerName: "Taille",
        width: 100,
        renderCell: (params: any) => {
          let octets = params.value || 0;
          // format the file size in a human-readable format in Mo
          const formattedSize = new Intl.NumberFormat("fr-FR", {
            style: "unit",
            unit: "megabyte",
            maximumFractionDigits: 2,
          }).format(octets / (1024 * 1024)); // Convert bytes to megabytes

          return (
            <div
              className={`flex flex-row gap-1 text-shadow_50 items-center  h-6 `}
            >
              {formattedSize}
            </div>
          );
        },
      },

      {
        field: "creation_date",
        headerName: "Creation",
        width: 150,
        renderCell: (params: any) => {
          // Customize color based on status value
          const date_int = params.value;
          // if date is today show "auj 22h33"
          const today = new Date();
          const isToday =
            date_int &&
            new Date(date_int).getDate() === today.getDate() &&
            new Date(date_int).getMonth() === today.getMonth() &&
            new Date(date_int).getFullYear() === today.getFullYear();
          if (isToday) {
            return (
              <div className="text-shadow_50">
                <span className="text-green-400 font-medium">auj </span>
                {new Date(date_int).toLocaleTimeString("fr-FR", {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
            );
          }

          const date = new Date(date_int);
          return (
            <div className="text-shadow_50">
              {date.toLocaleString("fr-FR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          );
        },
      },

      // Add more columns as needed
    ];

    // Create rows from the clients array
    let rows = allfiles.map((attestation: Attestation, index: number) => ({
      id: attestation.id || index + 1, // Use client's ID or default index
      ref: attestation.ref || null, // Include client's document reference
      num: attestation.num || "", // Use client's number or default
      name: attestation.name.trim() || "", // Use client's name or default 'Unknown'
      type: attestation.type || "insulator", // Use client's type or default 'insulator'
      type_text: attestation.type || "insulator", // Use client's type or default 'insulator'
      creation_date: attestation.creation_date.seconds * 1000 || 0,
      octets: attestation.file?.octets || 0, // Use file size in bytes or default to 0

      // Use client's city or default
    }));

    rows = rows.sort((a: any, b: any) => {
      return a.name
        .trim()
        .toLowerCase()

        .localeCompare(b.name.toLowerCase().trim());
    });

    return { rows, columns }; // Return rows and columns for the DataGrid
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}

export function transformXmlsToTable(
  allxmls: Xml[],
  activetab: any = "current",
  searchValue: string,
  partners_options: any[] = []
) {
  try {
    if (searchValue !== "") {
      allxmls = allxmls.filter((xml: Xml) => xml.name.includes(searchValue));
    }

    if (activetab === "recent") {
      allxmls = allxmls.filter((xml: Xml) => {
        return (
          xml.last_updated &&
          xml.last_updated.seconds > Date.now() / 1000 - 60 * 60 * 24 * 30
        ); // Last updated within the last week
      });
    } else if (activetab === "archived") {
      allxmls = allxmls.filter((xml: Xml) => {
        return (
          xml.last_updated &&
          xml.last_updated.seconds < Date.now() / 1000 - 60 * 60 * 24 * 30
        ); // Last updated more than a week ago
      });
    }
    const columns = [
      { field: "id", headerName: "ID", width: 300 },
      {
        field: "type",
        headerName: "Icon",
        width: 100,
        renderCell: (params: any) => {
          let type = params.value;

          return (
            <div className="flex flex-row items-center gap-4 text-shadow_25">
              <div
                className={`w-16 h-8 bg-gradient-to-tr from-green-400 to-black from-20% to-70%
          
            bg-gray-100 rounded-md flex items-center justify-center`}
              >
                <Icon1 icon_name="xml" size={20} fill={"white"}></Icon1>
              </div>
            </div>
          );
        },
      },

      {
        field: "name",
        headerName: "Nom",
        flex: 2,
        renderCell: (params: any) => {
          return (
            <div className={`flex flex-row gap-1 items-center  h-6 `}>
              {params.value?.substring(0, 75) || "Sans nom"}
            </div>
          );
        },
      },
      {
        field: "partner_id",
        headerName: "Partenaire",
        flex: 1,
        renderCell: (params: any) => {
          let partner = partners_options.find(
            (p: any) => p.value === params.value
          );
          if (partner) {
            return (
              <div className={`flex flex-row gap-1 items-center  h-6 `}>
                {partner.label || "Sans nom"}
              </div>
            );
          }
        },
      },
      {
        field: "rtb_compatible",
        headerName: "RTB",
        width: 50,
        renderCell: (params: any) => {
          let rtb_compatible = params.value;
          if (rtb_compatible === true) {
            return (
              <div className="flex flex-row gap-1 items-center  h-6 text-shadow_50">
                <Icon1 icon_name="done2" size={20} fill={"#1de36c"}></Icon1>
              </div>
            );
          }
          return (
            <div className="flex flex-row gap-1 items-center  h-6 text-shadow_50">
              <Icon1
                icon_name="non_conforme"
                size={20}
                fill={"#cccccc"}
              ></Icon1>
            </div>
          );
        },
      },

      {
        field: "octets",
        headerName: "Taille",
        width: 100,
        renderCell: (params: any) => {
          let octets = params.value || 0;
          // format the file size in a human-readable format in Mo
          const formattedSize = new Intl.NumberFormat("fr-FR", {
            style: "unit",
            unit: "megabyte",
            maximumFractionDigits: 2,
          }).format(octets / (1024 * 1024)); // Convert bytes to megabytes

          return (
            <div
              className={`flex flex-row gap-1 text-shadow_50 items-center  h-6 `}
            >
              {formattedSize}
            </div>
          );
        },
      },

      {
        field: "creation_date",
        headerName: "Creation",
        width: 150,
        renderCell: (params: any) => {
          // Customize color based on status value
          const date_int = params.value;
          // if date is today show "auj 22h33"
          const today = new Date();
          const isToday =
            date_int &&
            new Date(date_int).getDate() === today.getDate() &&
            new Date(date_int).getMonth() === today.getMonth() &&
            new Date(date_int).getFullYear() === today.getFullYear();
          if (isToday) {
            return (
              <div className="text-shadow_50">
                <span className="text-green-400 font-medium">auj </span>
                {new Date(date_int).toLocaleTimeString("fr-FR", {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
            );
          }

          const date = new Date(date_int);
          return (
            <div className="text-shadow_50">
              {date.toLocaleString("fr-FR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          );
        },
      },

      // Add more columns as needed
    ];

    // Create rows from the clients array
    let rows = allxmls.map((xml: Xml, index: number) => ({
      id: xml.id || index + 1, // Use client's ID or default index
      ref: xml.ref || null, // Include client's document reference
      name: xml.name.trim() || "", // Use client's name or default 'Unknown'
      creation_date: xml.creation_date.seconds * 1000 || 0,
      octets: xml.file?.octets || 0, // Use file size in bytes or default to 0
      rtb_compatible: xml.rtb_compatible || false, // Use rtb_compatible or default to true
      partner_id: xml.partner_id || "", // Use client's type or default 'insulator'

      // Use client's city or default
    }));

    rows = rows.sort((a: any, b: any) => {
      return a.name
        .trim()
        .toLowerCase()

        .localeCompare(b.name.toLowerCase().trim());
    });

    return { rows, columns }; // Return rows and columns for the DataGrid
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}

// Transform

interface FolderStatusBlockProps {
  status?: string;
}

export const FolderStatusBlock: React.FC<FolderStatusBlockProps> = ({
  status,
}) => {
  return (
    <div
      style={{
        backgroundColor:
          status === "conforme"
            ? colors.folder_status_bg.conforme
            : status === "non conforme"
            ? colors.folder_status_bg.nonconforme
            : status === "inspection"
            ? colors.primary
            : status === "rédaction"
            ? colors.black
            : colors.folder_status_bg.preinspection,
        borderRadius: 10,
        padding: "2px 8px",
        alignItems: "center",
        width: "fit-content",
        fontSize: 13,
      }}
    >
      <div
        className="flex flex-row items-center gap-2"
        style={{
          color:
            status === "conforme"
              ? colors.folder_status_color.conforme
              : status === "non conforme"
              ? colors.folder_status_color.nonconforme
              : status === "inspection"
              ? colors.white
              : status === "rédaction"
              ? colors.white
              : colors.folder_status_color.preinspection,
        }}
      >
        <Icon1
          fill={
            status === "conforme"
              ? colors.white
              : status === "non conforme"
              ? colors.white
              : status === "inspection"
              ? colors.white
              : status === "rédaction"
              ? colors.white
              : colors.grey_hard3
          }
          icon_name={
            status === "conforme"
              ? "done2"
              : status === "non conforme"
              ? "warning"
              : status === "inspection"
              ? "smartphone"
              : status === "rédaction"
              ? "plume"
              : "search"
          }
          size={16}
        ></Icon1>
        {status}
      </div>
    </div>
  );
};

interface ProgressBarProps {
  progress?: number;
  style?: object;
}
export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress = 0,

  style = {},
}) => {
  return (
    <div
      style={{
        width: "100%",

        height: 4,
        backgroundColor: colors.grey_soft,
        borderRadius: 30,
        ...style,
      }}
    >
      <div
        style={{
          width: `${progress * 100}%`,
          height: "100%",
          backgroundColor:
            progress === 1 ? colors.folder_status_bg.conforme : colors.primary,
          borderRadius: 5,
        }}
      ></div>
    </div>
  );
};
